export enum OrganicChannel {
  GOOGLE = 'google',
  BING = 'bing',
  YAHOO = 'yahoo',
  DUCKDUCKGO = 'duckduckgo',
  ECOSIA = 'ecosia',
}
